import React from 'react';
import './ChatCreateForm.scss';
import StepsProgress from "../../../pages/CreateChat/StepsProgress";
import Step1 from "../../../pages/CreateChat/Steps/Step1";
import Step2 from "../../../pages/CreateChat/Steps/Step2";
import Step3 from "../../../pages/CreateChat/Steps/Step3";
import Step4 from "../../../pages/CreateChat/Steps/Step4";
import {useNewChatStore} from "../../../store";

const ChatCreateForm = () => {

    const {currentStep} = useNewChatStore();

    const stepsComponnentReturn = () => {
        switch (currentStep) {
            case 2:
                return <Step2/>;
            case 3:
                return <Step3/>;
            case 4:
                return <Step4/>;
            default:
                return <Step1/>;
        }
    }

    return (
        <div className="ChatCreateForm">
            <StepsProgress currentStep={currentStep}/>
            {stepsComponnentReturn()}
        </div>
    );
};

export default ChatCreateForm;
